import React from "react";
import { FeatureFlags, useFeatureVariant } from "../../feature-flags/FeatureFlagContext";
import { t } from "../../i18n";

const PAY_VARIANT = "pay";

/**
 * Read-only banner showing which cashback backend (v1 bonus service, v2 cashback service)
 * currently pays out, based on the payout-mode feature flags.
 */
export function PayoutModeBanner() {
  const v1Mode = useFeatureVariant(FeatureFlags.BONUS_V1_CASHBACK_PAYOUT_MODE);
  const v2Mode = useFeatureVariant(FeatureFlags.CASHBACK_V2_PAYOUT_MODE);
  const v1Pays = v1Mode === PAY_VARIANT;
  const v2Pays = v2Mode === PAY_VARIANT;

  const modes = { v1Mode, v2Mode };
  let alertClass: string;
  let message: string;
  if (v1Pays && v2Pays) {
    alertClass = "alert-danger";
    message = t(
      "cashback.configs.payout-banner.both-pay",
      modes,
      `Both v1 and v2 cashback are set to pay — risk of double payouts. (v1: ${v1Mode}, v2: ${v2Mode})`,
    );
  } else if (!v1Pays && !v2Pays) {
    alertClass = "alert-warning";
    message = t(
      "cashback.configs.payout-banner.none-pay",
      modes,
      `Neither v1 nor v2 cashback is set to pay — no cashback will be paid out. (v1: ${v1Mode}, v2: ${v2Mode})`,
    );
  } else if (v1Pays) {
    alertClass = "alert-info";
    message = t("cashback.configs.payout-banner.v1-pays", modes, `Cashback payout routing: v1 is paying, v2 is not paying. (v1: ${v1Mode}, v2: ${v2Mode})`);
  } else {
    alertClass = "alert-info";
    message = t("cashback.configs.payout-banner.v2-pays", modes, `Cashback payout routing: v2 is paying, v1 is not paying. (v1: ${v1Mode}, v2: ${v2Mode})`);
  }

  return (
    <div
      className={`alert ${alertClass} mt-3`}
      role="alert"
      data-testid="payout-mode-banner"
    >
      {message}
    </div>
  );
}
